require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./multiple-line-ellipsis-css-effect.json") })
        }
      }, "path---multiple-line-ellipsis-css-effect");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---multiple-line-ellipsis-css-effect!./.cache/json/multiple-line-ellipsis-css-effect.json
// module id = 331
// module chunks = 231608221292675